import dayjs from "dayjs";
import React, { useEffect, useRef, useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import { useSelector } from "react-redux";
import Colors from "../../constant/Colors";
import { showInIQD } from "../../customFunction/Numeral/CurrencyFormat";
import { handleLoading } from "../../store/actions/loadingAction";
import { makePurchase } from "../../store/actions/purchasesActivityAction";
import {
  getGuestByBioStarID,
  getUserByBioStarID,
} from "../../store/actions/usersAction";
import { t } from "i18next";
import { IDNumberGenerator } from "../../customFunction/IDGenerator";
import { convertCurrency } from "../../store/actions/dollarPricesAction";
import useSWR from "swr";
import { Error, fetcher, Loading } from "../../components/UI/TableView/ShowPaginationData";
const smalltalk = require("smalltalk");

function Caffetteria() {
  const [currentCode, setCurrentCode] = useState("");
  const [currentUser, setCurrentUser] = useState(false);
  const [cart, setCart] = useState(false);
  const [totalPrice, setTotalPrice] = useState(0);
  const { data: CafeteriaItems, isLoading, error } = useSWR('/cafeteria-stocks?fromReception', fetcher)
  const centerId = JSON.parse(localStorage.getItem("centerId")).centerId;
  const [cafeItems, setCafeItems] = useState(false);
  const { data: CafeteriaStorage, isLoading: isLoadingStorage, error: errorStorage } = useSWR('/cafeteria-storage/' + centerId, fetcher, {
    refreshInterval: 1000
  })
  const currentAdmin = useSelector((state) => state.authentication.user);
  const [sellingType, setSellingType] = useState(0) // 0 for user 1 for cash
  const [isFree, setIsFree] = useState(false) // 0 for user 1 for cash
  const inputRef = useRef(null);

  const onChangeCode = (val) => {
    setCurrentCode(val);
  };

  const onChangeSellingType = (val) => {
    setSellingType(val)
    onClearUser()
  }

  const onClearUser = () => {
    setCurrentCode("");
    setCurrentUser(false);
    setCart(false);
    setIsFree(false)
    inputRef?.current?.focus();
  };

  const onSubmit = async () => {
    try {
      const currentCenterId = JSON.parse(
        localStorage.getItem("centerId")
      ).centerId;

      handleLoading();
      const moneyBeforeCalc = currentUser ? currentUser.wallet.money : null

      let obj = {
        price: totalPrice,
        name: currentUser?.name || "Guest User",
        items: cart,
        moneyBeforeCalc,
        bioStarID: currentUser?.bioStarID || IDNumberGenerator(8),
        centerId: currentCenterId,
        adminId: currentAdmin._id,
        isFree: currentUser?.wallet?.isFree || isFree || false,
        priceByDollar: convertCurrency(totalPrice, 'USD'),
      };

      await makePurchase(obj, currentCode.length > 12 ? 1 : sellingType === 1 ? 2 : 0);
      setCart(false);
      setCurrentUser(false);
      setCurrentCode("");

      inputRef?.current?.focus();
      handleLoading();
    } catch (e) {
      console.log(e)
      // smalltalk.alert(e);
      setCart(false);
      setCurrentUser(false);
      setCurrentCode("");
      setIsFree(false)
      handleLoading();
    }
  };

  const onSelectItem = (item) => {
    let arr = cart || [];

    arr.push({ itemId: item._id, quntity: 1, price: item.prices.singlePrice });

    setCart(() => [...arr]);
  };

  const calculatePrice = () => {
    let arr = cart || [];

    let tp = 0;

    arr.forEach((cr) => {
      tp += cr.price * cr.quntity;
    });
    if (isFree && isFree === '15%') tp = tp - (tp * 0.15)
    setTotalPrice(tp);
  };

  useEffect(() => {
    calculatePrice();
  }, [cart, isFree]);

  const onChangeQuantity = (id, type) => {
    let arr = cart;
    let newArr = [];
    let exeption = null;
    try {
      arr.forEach((cr, i) => {
        if (cr.itemId === id) {
          arr[i].quntity += type === 0 ? -1 : 1;
          if (arr[i].quntity === 0) {
            throw exeption;
          }
        }
      });

      setCart(() => [...arr]);
    } catch (e) {
      arr.forEach((cr, i) => {
        if (cr.itemId !== id) {
          newArr.push(cr);
        }
      });
      setCart(() => [...newArr]);
    }
  };

  const findCurrentUser = async () => {
    try {
      if (!Number(currentCode)) {
        onClearUser()
        return
      }
      handleLoading();
      if (!currentCode) throw "Error";
      let user;
      if (currentCode.length > 12) {
        user = (await getGuestByBioStarID(currentCode))[0];
      } else user = (await getUserByBioStarID(currentCode))[0];
      if (!user) throw "Error";
      setCurrentUser({ ...user });
      inputRef.current.blur();
      handleLoading();
    } catch (e) {
      handleLoading();
      console.log(e);
      smalltalk.alert(
        t("error"),
        t('userNotFoundPleaseVerifyID')
      );
    }
  };

  const onClickFree = () => {
    setIsFree(!isFree)
  }

  const onClickDiscount = () => {
    if (isFree === '15%') {
      setIsFree(false)
    } else {
      setIsFree('15%')
    }
  }

  if (isLoading) {
    return <Loading />
  }

  if (error) {
    return <Error />
  }
  // console.log(CafeteriaItems)
  return (
    <div className="flex flex-row items-center w-full justify-evenly">
      {CafeteriaItems && CafeteriaItems.length > 0 && <><Menu
        CafeteriaItems={CafeteriaItems}
        cart={cart}
        onSelectItem={onSelectItem}
        storage={CafeteriaStorage?.storage}
        onChangeQuantity={onChangeQuantity}
        currentUser={currentUser}
        sellingType={sellingType}
      />
        <CurrentUsers
          CafeteriaItems={CafeteriaItems}
          inputRef={inputRef}
          cart={cart}
          isFree={isFree}
          findCurrentUser={findCurrentUser}
          totalPrice={totalPrice}
          currentUser={currentUser}
          currentCode={currentCode}
          onChangeCode={onChangeCode}
          onClearUser={onClearUser}
          onSubmit={onSubmit}
          onClickFree={onClickFree}
          onClickDiscount={onClickDiscount}
          sellingType={sellingType}
          onChangeSellingType={onChangeSellingType}
        /></>}
    </div>
  );
}

const CurrentUsers = ({
  currentUser,
  onChangeCode,
  currentCode,
  onClearUser,
  cart,
  totalPrice,
  onSubmit,
  inputRef,
  CafeteriaItems,
  findCurrentUser,
  sellingType,
  onChangeSellingType,
  onClickFree,
  isFree,
  onClickDiscount
}) => {
  return (
    <div
      style={{
        display: "flex",
        width: "25%",
        maxHeight: "95%",
        minHeight: "95%",
        justifyContent: "space-between",
        flexDirection: "column",
        borderWidth: 2,
      }}
    >
      <div style={{}} >
        <User
          findCurrentUser={findCurrentUser}
          currentUser={currentUser}
          currentCode={currentCode}
          onClearUser={onClearUser}
          onChangeCode={onChangeCode}
          inputRef={inputRef}
          cart={cart}
          isFree={isFree}
          onClickFree={onClickFree}
          totalPrice={totalPrice}
          sellingType={sellingType}
          onChangeSellingType={onChangeSellingType}
          onClickDiscount={onClickDiscount}
        />
        <SelectedItem CafeteriaItems={CafeteriaItems} cart={cart} />
      </div>
      <div>
        <Prices isFree={isFree} totalPrice={totalPrice} />
        <SubmitButton
          onSubmit={onSubmit}
          cart={cart}
          sellingType={sellingType}
          isFree={isFree}
          currentUser={currentUser}
          totalPrice={totalPrice}
        />
      </div>
    </div>
  );
};

const User = ({
  currentUser,
  currentCode,
  onChangeCode,
  onClearUser,
  inputRef,
  totalPrice,
  findCurrentUser,
  sellingType,
  onChangeSellingType,
  cart,
  onClickFree,
  onClickDiscount
}) => {
  const onChangeHandler = (e) => {
    let val = e.target.value;
    if (!currentUser) onChangeCode(val);
  };

  const onClickType = (val) => {
    onChangeSellingType(Number(val))
  }

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        borderBottomWidth: 1,
        borderColor: "rgba(29,29,29,0.2)",
      }}
    >
      <div className="flex justify-between w-full" >
        <div style={{ fontFamily: 'Montserrat-Bold' }} onClick={onClickType.bind(this, 0)} className={`flex items-center justify-center w-1/2 h-12 text-sm text-center ${sellingType === 0 ? 'bg-green-600 text-white' : 'text-black'} border cursor-pointer`} >
          {t('code')}
        </div>
        <div style={{ fontFamily: 'Montserrat-Bold' }} onClick={onClickType.bind(this, 1)} className={`flex items-center justify-center w-1/2 h-12 text-sm text-center  ${sellingType === 1 ? 'bg-green-500 text-white' : 'text-black'} border cursor-pointer`}>
          {t('cash')}
        </div>
      </div>
      <>

        {sellingType === 0 && <div
          style={{ display: "flex", flexDirection: "column", padding: 10 }}
        >
          <h1
            style={{
              color: !currentUser ? "rgba(29,29,29,0.5)" : Colors.mainGreenColor,
              fontSize: 18,
            }}
          >
            {currentUser ? currentUser.name : t('noUser')}
          </h1>
          {currentUser && (
            <h1
              style={{
                color:
                  totalPrice > (currentUser?.wallet?.money || 0)
                    ? "red"
                    : Colors.mainGreenColor,
                fontSize: 15,
              }}
            >
              {showInIQD(currentUser?.wallet?.money || 0, "IQD", "IQD")}
            </h1>
          )}
          <div className="flex my-2" style={{ height: 40, }} >
            <input
              ref={inputRef}
              type={"text"}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  findCurrentUser();
                }
              }}
              autoFocus
              style={{ backgroundColor: Colors.whiteCardColor, padding: 5 }}
              value={currentCode}
              onChange={onChangeHandler}
            />
            {currentUser && (
              <>
                <a
                  onClick={onClearUser}
                  style={{
                    display: "flex",
                    height: "100%",
                    width: 50,
                    backgroundColor: "#e74b3c",
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                >
                  <AiOutlineClose size={22} color="#fff" />
                </a>
              </>)}
          </div>
          {currentUser && cart?.length > 0 && <p onClick={onClickDiscount} className="my-2 text-blue-500 underline cursor-pointer" >{t('discountForEmployees15')}</p>}

        </div>}

      </>

    </div>
  );
};

const SelectedItem = ({ cart, CafeteriaItems }) => {
  return (
    <div
      style={{
        display: "table-row",
        overflow: "auto",
        width: "100%",
      }}
    >
      {cart &&
        cart.map((cr, i) => {
          return (
            <SelectedItemIndex
              CafeteriaItems={CafeteriaItems}
              item={cr}
              key={i}
            />
          );
        })}
    </div>
  );
};

const SelectedItemIndex = ({ item, CafeteriaItems }) => {
  const [currentItem, setCurrentItem] = useState(false);

  const setUpCurrentItem = () => {
    let check = CafeteriaItems.find((a) => a._id === item.itemId);

    setCurrentItem(check);
  };

  useEffect(() => {
    if (item) {
      setUpCurrentItem();
    }
  }, [item]);

  return (
    <div
      style={{
        display: "flex",
        height: 100,
        width: 'auto',
        margin: 18,
        borderWidth: 1,
        flexDirection: "row",
        alignItems: "center",
        //justifyContent: "space-between",
      }}
    >
      {currentItem && (
        <img src={currentItem.imageUri} style={{ width: 80, height: 90 }} />
      )}

      {currentItem && (
        <div style={{ width: 130 }}>
          <h1>
            ({item.quntity}) - {currentItem.name}
          </h1>
        </div>
      )}
      {currentItem && (
        <div style={{ marginLeft: 15 }}>
          <h1 style={{ fontSize: 25 }}>
            {showInIQD(item.price * item.quntity, "IQD", "IQD")}
          </h1>
        </div>
      )}
    </div>
  );
};

const Prices = ({ totalPrice }) => {
  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        height: "30%",
        alignItems: "center",
        justifyContent: "space-evenly",
        padding: 10,
        borderTopWidth: 1,
        borderColor: "rgba(29,29,29,0.2)",
      }}
    >
      <h1 style={{ fontSize: 20 }}>
        {t('totalPrice')}: {showInIQD(totalPrice, "IQD", "IQD")}
      </h1>
    </div>
  );
};

const Item = ({ item, cart, sellingType, onSelectItem, onChangeQuantity, currentUser, currentItemInStorage }) => {
  const [isSelected, setIsSelected] = useState(false);
  const [isValid, setIsValid] = useState(false);
  const onSelectItemHandler = () => {
    if (currentUser || sellingType === 1) onSelectItem(item);
  };

  const checkForSelected = () => {
    let check = false;
    if (cart && cart.length) {
      check = cart?.find((a) => a.itemId === item._id);
    }
    setIsSelected(check);
  };

  const onChangeQuantityHandler = (type) => {
    onChangeQuantity(isSelected.itemId, type);
  };

  useEffect(() => {
    checkForSelected();
  }, [cart]);

  return (
    <div
      style={{
        display: "flex",
        height: 300,
        width: 200,
        margin: 10,
        marginLeft: 10,
        marginRight: 10,
        borderWidth: 1,
        justifyContent: "space-between",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      <img
        style={{ display: "flex", alignSelf: "center", height: "60%" }}
        src={item.imageUri}
      />

      <div
        style={{
          display: "flex",
          height: "20%",
          width: "100%",
          zIndex: 100,
          alignItems: "center",
          justifyContent: "space-between",
          paddingRight: 5,
          paddingLeft: 5,
        }}
        className="border-t"
      >
        <h1
          style={{
            fontSize: 15,
            marginTop: 7,
            color: "#292929",
            width: "50%",
            lineBreak: "strict",
            height: "100%",
          }}
        >
          {item.name.substring(0, 15)}
          {item.name.length > 15 && "..."}
        </h1>
        <h1
          style={{
            fontSize: 15,
            marginTop: 7,
            color: "#292929",
            height: "100%",
          }}
        >
          {showInIQD(item.prices.singlePrice, "IQD", "IQD")}
        </h1>
      </div>
      <div className="w-full px-1 text-sm text-left" >
        {currentItemInStorage ? <h1 >
          {currentItemInStorage.quantity} available
        </h1> : <h1><br /></h1>}
      </div>
      {isSelected ? (
        <div
          style={{
            display: "flex",
            height: "20%",
            width: "100%",
            backgroundColor: Colors.mainAqwaBlue,
            zIndex: 100,
            alignItems: "center",
            justifyContent: "space-between",
            flexDirection: "row",
          }}
        >
          <div
            onClick={onChangeQuantityHandler.bind(this, 0)}
            style={{
              display: "flex",
              width: "33%",
              height: "100%",
              backgroundColor: "#fff",
              alignItems: "center",
              justifyContent: "center",
              borderWidth: 1,
              cursor: "pointer",
            }}
          >
            <h1 style={{ fontSize: 40, marginTop: 10 }}>-</h1>
          </div>
          <div
            style={{
              display: "flex",
              width: "33%",
              height: "100%",
              backgroundColor: "#fff",
              alignItems: "center",
              justifyContent: "center",
              borderWidth: 1,
            }}
          >
            <h1 style={{ fontSize: 25, marginTop: 7 }}>{isSelected.quntity}</h1>
          </div>
          <div
            onClick={onChangeQuantityHandler.bind(this, 1)}
            style={{
              display: "flex",
              width: "33%",
              height: "100%",
              backgroundColor: "#fff",
              alignItems: "center",
              justifyContent: "center",
              borderWidth: 1,
              cursor: "pointer",
            }}
          >
            <h1 style={{ fontSize: 35, marginTop: 10 }}>+</h1>
          </div>
        </div>
      ) : (
        <div
          onClick={onSelectItemHandler}
          style={{
            display: "flex",
            height: "20%",
            width: "100%",
            backgroundColor: currentUser || sellingType === 1
              ? Colors.mainAqwaBlue
              : "rgba(29,29,29,0.7)",
            zIndex: 100,
            alignItems: "center",
            justifyContent: "center",
            cursor: currentUser || sellingType === 1 ? "pointer" : "no-drop",
          }}
        >
          <h1 style={{ color: "#fff" }}>{t('select')}</h1>
        </div>
      )}
    </div>
  );
};

const Menu = ({
  cart,
  onSelectItem,
  onChangeQuantity,
  currentUser,
  CafeteriaItems,
  sellingType,
  storage
}) => {
  return (
    <div
      style={{
        display: "flex",
        marginLeft: 60,
        width: "65%",
        maxHeight: "95%",
        minHeight: "95%",
        //   borderWidth: 2,
        flexDirection: "row",
        flexWrap: "wrap",
        overflow: "auto",
        justifyContent: "space-between",
      }}
    >
      {CafeteriaItems &&
        CafeteriaItems.map((d, i) => {
          const currentItemInStorage = storage?.find(a => a.itemId === d._id)

          return (
            <Item
              currentUser={currentUser}
              onChangeQuantity={onChangeQuantity}
              item={d}
              currentItemInStorage={currentItemInStorage}
              sellingType={sellingType}
              onSelectItem={onSelectItem}
              cart={cart}
              key={i}
            />
          );
        })}
    </div>
  );
};

const SubmitButton = ({ onSubmit, cart, isFree, sellingType, currentUser, totalPrice }) => {
  const [isValid, setIsValid] = useState(false);

  const checkForValidation = () => {
    let check = true;
    if (isFree) {
      setIsValid(true)
      return
    } else if (sellingType === 1 && cart?.length > 0) {
      setIsValid(true)
      return
    }
    let userBalance = currentUser?.wallet?.money
      ? currentUser?.wallet?.isFree
        ? Math.pow(10, 1000)
        : currentUser?.wallet?.money
      : currentUser?.wallet?.isFree ? Math.pow(10, 1000) : 0;
    if (
      !currentUser.wallet ||
      !currentUser ||
      totalPrice > userBalance ||
      !cart ||
      cart.length === 0
    ) {
      check = false;
    }

    setIsValid(check);
  };

  useEffect(() => {
    checkForValidation();
  }, [cart, currentUser, isFree, sellingType, totalPrice]);

  return (
    <div
      onClick={isValid ? onSubmit : () => { }}
      style={{
        display: "flex",
        width: "100%",
        height: "30%",
        alignItems: "center",
        justifyContent: "space-evenly",
        padding: 10,
        borderTopWidth: 1,
        borderColor: "rgba(29,29,29,0.2)",
        backgroundColor:
          isValid > 0 ? Colors.mainAqwaBlue : "rgba(29,29,29,0.7)",
        cursor: isValid > 0 ? "pointer" : "no-drop",
      }}
    >
      <h1 style={{ fontSize: 20, color: "#fff" }}>Submit</h1>
    </div>
  );
};

export default Caffetteria;
